/* PB Stats — animate count-up when card enters viewport
   Source parity: .pure-brolic-html/script.js stat counters
*/
(function () {
  'use strict';

  function animateCount(el) {
    var target = parseInt(el.getAttribute('data-count'), 10);
    if (isNaN(target)) return;
    var suffix = el.getAttribute('data-suffix') || '';
    var duration = 1800;
    var startTime = null;

    function tick(now) {
      if (!startTime) startTime = now;
      var progress = Math.min((now - startTime) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = Math.round(target * eased);
      el.textContent = value + suffix;
      if (progress < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function init(root) {
    if (!root || root.dataset.pbInit === '1') return;
    root.dataset.pbInit = '1';

    var nums = root.querySelectorAll('.pb-stats-card__number[data-count]');
    if (!nums.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      nums.forEach(function (el) {
        var suffix = el.getAttribute('data-suffix') || '';
        el.textContent = el.getAttribute('data-count') + suffix;
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCount(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });

    nums.forEach(function (el) { observer.observe(el); });
  }

  function initAll() { document.querySelectorAll('.pb-stats').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('.pb-stats');
    if (root) init(root);
  });
})();
